<template>
  <div class="title-bar">
    <div class="title-bar__left">
      <img style="height: 40px;" src="../../assets/img/logo/logo1.png" />
      <img src="../../assets/img/logo/logo2.png" />
      <span class="title-bar__title">{{ systemTitle }}</span>
    </div>
    <div class="one"></div>
    <div class="title-bar__right" @click.stop="clickUser">
      <!-- <img class="title-bar__user_avatar" src="../../assets/img/nav/defaultAvatar.png" @click.stop="clickUser" /> -->
      <img class="title-bar__user_avatar" :src="userPhoto" />
      <span class="title-bar__user_name"
        >{{ userInfo.chName }}【{{ userInfo.userName }}】</span
      >
    </div>
    <navTip
      ref="navTip"
      @userInfoClick="userInfoClick"
      @clickChangePwd="clickChangePwd"
    ></navTip>
    <userInfoD ref="userInfoD"></userInfoD>
    <changepwd ref="changepwd"></changepwd>
  </div>
</template>

<script>
import userInfoD from "../../views/system/user/userInfo.vue";
import changepwd from "../../views/system/user/changepwd.vue";
import navTip from "./navTip.vue";
export default {
  data() {
    return {
      userInfo: {},
      userPhoto: "",
      systemTitle: "",
    };
  },
  computed: {
    GetsystemTitle() {
      // 从环境变量中获取系统标题，如果不存在则使用默认值
      return process.env.VUE_APP_SYSTEM_TITLE || "应用系统";
    },
  },
  components: {
    navTip,
    userInfoD,
    changepwd,
  },
  created() {
    // 从Vuex store获取配置信息
    this.systemTitle = process.env.VUE_APP_SYSTEM_TITLE || "应用系统";
  },
  mounted() {
    this.$nextTick(() => {
      this.getUserInfo();
    });
  },
  methods: {
    // 获取用户信息
    getUserInfo() {
      if (localStorage.getItem("userdata")) {
        this.userInfo = JSON.parse(localStorage.getItem("userdata")).userInfo;
        if (this.userInfo.photoImg) {
          this.userPhoto = "data:image/png;base64," + this.userInfo.photoImg;
        }
      }
    },

    // 更改密码
    clickChangePwd() {
      this.$refs.changepwd.showChangePwdDialog();
    },

    // 点击个人信息
    userInfoClick() {
      this.$refs.userInfoD.showUserInfoDialog(this.userInfo);
    },
    // 点击用户头像
    clickUser() {
      this.$refs.navTip.showTip(this.userInfo);
    },

    // 关闭应用
    quit() {
      this.$confirm("关闭应用, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        // 在Web环境中无法直接控制窗口，这里仅作提示
        this.$message.info("在Web环境中无法直接关闭应用");
      });
    },
  },
};
</script>

<style scoped>
.title-bar {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* background-color: #3370ff; */
  background-color: rgb(22, 46, 123);
  height: 3.5rem;
  color: #ffffff;
  -webkit-app-region: drag;
}

.title-bar__user_avatar {
  width: 25px;
  height: 25px;
  margin-left: 15px;
  border: 1px solid #fff;
  border-radius: 50%;
  -webkit-app-region: no-drag;
}

.title-bar__user_name {
  color: #ffffff;
  margin-left: 10px;
  font-size: 12px;
}

.title-bar__title {
  margin-left: 10px;
  font-weight: 600;
  font-size: 24px;
  font-family: 楷体;
}

.title-bar__right {
  margin-right: 20px;
}

.title-bar__icon {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  cursor: pointer;
}

.title-bar__icon:hover {
  background: #55aaff;
}

.title-bar__icon img {
  width: 20px;
  height: 20px;
}

.tbi_img {
  width: 18px !important;
  height: 18px !important;
}

.title-bar__left,
.title-bar__right {
  display: flex;
  align-items: center;
  /* -webkit-app-region: drag; */
}
.title-bar__left img{
		width: auto;
		height: 60px;
}
/* /deep/ .el-input__inner {
		background: #6996ff;
		color: #ffffff;
		border: none;
	} */

.one {
  display: flex;
  align-items: center;
  -webkit-app-region: no-drag;
}

.one_1 {
  font-size: 20px;
  margin-right: 10px;
}

.one_2 {
  width: 450px;
}
</style>